import React, { Component } from 'react';
import { InputField, Field } from '../form';

import {
  FormGroup,
  Button
} from 'reactstrap';



import filter from 'lodash/filter';
import first from 'lodash/first';
import size from 'lodash/size';
import keys from 'lodash/keys';
import map from 'lodash/map';
import difference from 'lodash/difference';

import classNames from 'classnames';


import { FieldArray } from 'react-final-form-arrays';
import { FormSpy } from 'react-final-form';
import { getIn } from 'final-form';
import createDecorator from 'final-form-calculate';


import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Row, Col } from 'reactstrap';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

// Icons
import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faTrashAlt from '@fortawesome/fontawesome-pro-light/faTrashAlt';
import faPlus from '@fortawesome/fontawesome-pro-light/faPlus';
import faEye from '@fortawesome/fontawesome-pro-light/faEye';
import faEyeSlash from '@fortawesome/fontawesome-pro-light/faEyeSlash';
import faBars from '@fortawesome/fontawesome-pro-light/faBars';
import faEllipsisH from '@fortawesome/fontawesome-pro-regular/faEllipsisH';
import faStar from '@fortawesome/fontawesome-pro-regular/faStar';
import faStarSolid from '@fortawesome/fontawesome-pro-solid/faStar';


// import DropdownSelectAdapter from '../form/DropdownSelectAdapter';
import IconPickerAdapter from '../helpers/IconPickerAdapter';
import NetworkIcon from './NetworkIcon';

import sublinksScheme from './schemes';
import SchemedField from './SchemedField';



const getDndListStyle = isDraggingOver => ({
  // background: isDraggingOver ? 'lightblue' : 'lightgrey',
  // padding: 8,
  // width: 250,
  // paddingTop: '1rem'
});

const getDndItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  // styles we need to apply on draggables
  ...draggableStyle,
  marginBottom: '1rem',
});


class SublinksList extends Component {
  
  constructor(props) {
    super(props);
    this.onDragEnd = this.onDragEnd.bind(this);
  }
  
  onDragEnd(result) {
    const { fields } = this.props
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    
    // good times
    if (window.navigator.vibrate) {
      window.navigator.vibrate(100);
    }
    
    fields.move(result.source.index, result.destination.index)
  }
  
  render() {
    const { fields, children } = this.props
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getDndListStyle(snapshot.isDraggingOver)}
            >
              {fields.map((name, index) => (
                <Draggable key={name} draggableId={name} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      style={getDndItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}
                    >
                      {children({provided, snapshot, name, index})}
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    )
  }
}



class HighlightControl extends React.Component {
  
  componentWillReceiveProps(nextProps) {    
    const { values: {settings} } = nextProps
    const oldSettings = this.props.values.settings
    
    if ( settings === oldSettings )
      return
    
    const highlighted = filter([...settings.buttons, ...settings.social_links, ...settings.messengers], 'highlight') 
    
    if (highlighted.length <= 1)
      return
    
    const oldHighlighted = filter([...oldSettings.buttons, ...oldSettings.social_links, ...oldSettings.messengers], 'highlight')
    
    const selected = difference(highlighted, oldHighlighted)[0]
    
    const newSettings = {...settings, 
      buttons: map(settings.buttons, (b) => (selected !== b ? {...b, highlight: false} : b)),
      social_links: map(settings.social_links, (b) => (selected !== b ? {...b, highlight: false} : b)),
      messengers: map(settings.messengers, (b) => (selected !== b ? {...b, highlight: false} : b)),
    } 
    nextProps.form.change('settings', newSettings)
  }
  
  render () {
    return null
  }
}


class SublinkControls extends Component {
  
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    
    this.state = {
      opened: false
    }
    
  }
  
  toggle() {
    this.setState({opened: !this.state.opened})
  }
  
  render() {
    const { fields, index, name, deleteOnly } = this.props
    
    return (<React.Fragment>
      { deleteOnly !== true ? <Dropdown isOpen={this.state.opened} toggle={this.toggle}>
        <DropdownToggle className="btn btn-link-outline clickable-icon" title="Options">
          <FA icon={faEllipsisH} />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem>
            <Row>
              <Col xs={6} className="text-center nopadd">
                <span className="btn btn-link" onClick={() => fields.remove(index) }>
                  <FA icon={faTrashAlt} />
                  <div className="xsmall">Delete</div>
                </span>
              </Col>
              <Col xs={6} className="text-center nopadd">
          
                <Field name={`${name}.highlight`} 
                  render={({input}) => (
                    <span className="btn btn-link" onClick={() => input.onChange(!input.value) }>
                      <FA icon={input.value === true ? faStarSolid : faStar} />
                      <div className="xsmall">Highlight</div>
                    </span>
                  )}
                />
              
              </Col>
            </Row>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      
      :
      
      <div className="btn btn-link-outline clickable-icon" title="Delete" onClick={() => fields.remove(index) } >
        <FA icon={faTrashAlt}/>
      </div>
      }
    </React.Fragment>)
  }
  
}


const ButtonsList = ({fields, submitting}) => (
  <SublinksList submitting={submitting} fields={fields}>
    {({provided, snapshot, name, index}) =>(
      <div className={classNames({'form-group': true, 'with-stack': true})}>
        <div className={classNames({"side-controls":true, "drag-handle":true, 'd-none': fields.length <= 1})} {...provided.dragHandleProps}>
          <FA icon={faBars} />
        </div>
  
        <div className="input-stack">
          <InputField 
            meta={{submitting}} 
            name={`${name}.url`} type="text"
            placeholder="http://url..."
            disabled={fields.value[index].can_change_url === false}
            className="input-stack-row"
          />
          <div className="input-group input-stack-row">
            <Field
              className="input-group-prepend"
              name={`${name}.icon`}
              placeholder={"Icon"}
              component={IconPickerAdapter}
            />
            <InputField
              meta={{submitting}}
              name={`${name}.title`} type="text"
              placeholder="Title"
            />
          </div>
        </div>
        
        <div className="input-stack-controls">
          
          <Field name={`${name}.visible`}>
            {({input}) => (
              <div className="btn btn-link-outline clickable-icon" title="Hide" onClick={() => input.onChange(!input.value)}>
                {(input.value === true) ? <FA icon={faEye} /> : <FA icon={faEyeSlash} />}
              </div>
            )}
          </Field>
          
          <SublinkControls {...{fields, index, name}} />
        </div>
      </div>
    )}
  </SublinksList>
)


const sublinksFieldRegEx = /(settings\.(messengers|social_links)\[(\d+)\])\.(handle|type|text|subject|body)/
export const sublinksUrlDecorator = createDecorator(
  {
    field: sublinksFieldRegEx, // when a field matching this pattern changes...
    updates: (itemValue, name, allValues) => {
      const matches = name.match(sublinksFieldRegEx)
      
      if (!matches)
        return {}
      
      const listKey = matches[2]
      // const idx = matches[3]
      const itemKey = matches[1]//name.replace(/\.[^\.]+$/i, '')
      const item = getIn(allValues, itemKey)//allValues.settings[listKey][idx] 
      
      if (!item)
        return {}
      
      const mutatorFn = (sublinksScheme[listKey][item.type] || {}).urlMutator
      if (mutatorFn){
        const res = {
          [`${itemKey}.url`]: item.handle && mutatorFn(item)
        }
        return res
      }
      return {}
    }
  }
)


const SchemedList = ({scheme, fields, submitting, deleteOnly}) => {
  const selectedFields = fields.value ? map(fields.value, 'type') : []
  const placeholder = <NetworkIcon type={first(difference(keys(scheme), selectedFields)) || 'facebook'} />
  
  return (<SublinksList submitting={submitting} fields={fields}>
    {({provided, snapshot, name, index}) => {
      const fieldValue = fields.value[index];
      if (!fieldValue)
        return null
      
      return (<FormGroup className="with-stack">
      <div className={classNames({"side-controls":true, "drag-handle":true, 'd-none': fields.length <= 1})} {...provided.dragHandleProps}>
        <FA icon={faBars} />
      </div>
      
      <SchemedField {...{name, fieldValue, placeholder, scheme, submitting, selectedFields}} />
      <div className="input-stack-controls">
        <SublinkControls {...{fields, index, name, deleteOnly}} />
      </div>
      
      
    </FormGroup>)
    }}
  </SublinksList>)
}






const BioLinkButtonsTab = ({values, submitting, unshift, push}) => (<React.Fragment>
  <FormSpy
    subscription={{ active: true, values: true }}
    component={HighlightControl}
  />
    
  <FormGroup className="mb-5">
    <Button color="primary" className="float-right mb-3"
      size="sm"
      disabled={values.settings && size(values.settings.messengers) >= 6}
      onClick={() => unshift('settings.messengers', {visible:true})}>
      <FA icon={faPlus} />
    </Button>
  
    <label className="">Messengers:</label>

    <FieldArray name="settings.messengers">
      {({ fields }) => <SchemedList submitting={submitting} scheme={sublinksScheme['messengers']} fields={fields} />}
    </FieldArray>
  
  </FormGroup>
  
  <FormGroup className="mb-5">
    <Button color="primary" className="float-right mb-3"
      size="sm"
      onClick={() => unshift('settings.buttons', {visible:true, url: ""})}>
      <FA icon={faPlus} /> Add link
    </Button>
  
    <label>Links:</label>
  
    <FieldArray name="settings.buttons">
      {({ fields }) => <ButtonsList submitting={submitting} fields={fields} />}
    </FieldArray>
  </FormGroup>
  
  <FormGroup className="mb-5">
    <Button color="primary" className="float-right mb-3"
      size="sm"
      disabled={values.settings && size(values.settings.social_links) >= 7}
      onClick={() => unshift('settings.social_links', {visible:true})}>
      <FA icon={faPlus} />
    </Button>
    
    <label>Social networks:</label>
    
    <FieldArray name="settings.social_links">
      {({ fields }) => <SchemedList submitting={submitting} deleteOnly={true} scheme={sublinksScheme['social_links']} fields={fields} />}
    </FieldArray>
  </FormGroup>
      
</React.Fragment>)


export default BioLinkButtonsTab;


// WEBPACK FOOTER //
// ./src/components/SmartLinks/BioLinkButtonsTab.js